import currency from 'currency.js';
import ReactGA from 'react-ga4';
import { components } from 'react-select';
import htmlToDraft from 'html-to-draftjs';
import { EditorState, ContentState } from 'draft-js';


export const FilePath = (path) => {
  return process.env.REACT_APP_FILES_BASE_URL + path;
}

export const FormatNameToFilePath = (name) => {
    return name.toLowerCase().replace(/ {2}/g, " ").replace(/ /g, "-").replace(/(-)+/g, "-").replace(/[']/g, "").replace(/[.]/g, "");
}

export const EventTrack = (category, action, label) => {
    ReactGA.event({
        category: category,
        action: action,
        label: label,
    })
}

export const FormatHTMLForWYSIWYGEditor = (htmlString) => {
    if (!htmlString || typeof htmlString !== 'string') {
        return EditorState.createEmpty();
    }
    var blocksFromHtml = htmlToDraft(htmlString);
    var { contentBlocks, entityMap } = blocksFromHtml;
    var contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
    return EditorState.createWithContent(contentState);
}

export const FormatPhoneNumber = (phoneNumberString) => {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    }
    return null;
}

export const FormatMoney = (number) => {
    if (!number && number !== 0) return null;
    return currency(number , { separator: ',', symbol: '$',   negativePattern: `(!#)` }).format();
}

export const FormatMoneyNoDollarSign = (number) => {
    if (!number && number !== 0) return null;
    return currency(number , { separator: ',', symbol: '',   negativePattern: `(!#)` }).format();
}

export const FormatNumber = (number) => {
    if (!number && number !== 0) return null;
    return number.toString().replace(/[^\d^.]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const UnFormatMoney = (string) => {
    return currency(string).value;
}

export const toTitleCase = (str) => {
  if (!str) return str;
  return str.toLowerCase().replace(/\b\w/g, s => s.toUpperCase());
}

export const FormatPhoneInput = (value) => {
    if (!value) return value;
    const phoneNumber = value.replace(/[^\d]/g, "");
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) {
        return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
    }
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
}

export const DisplayHtml = (stringWithHtml) => {
    var createMarkup = (html) => {
        return { __html: html };
    };
    return <div dangerouslySetInnerHTML={createMarkup(stringWithHtml)} />;
}

export const ReactSelectInputNoAutoComplete = ({ children, ...props }) => {
    return (
        <components.Input {...props} autoComplete="chrome-off">
            {children}
        </components.Input>
    );
};

export const validateCoordinates = (value) => {
    const example = 'ex: "43.611801917165366, -116.21277785182387".Right click anywhere on a google map to see the coordinates, click the coordinates to copy.'
    // 1. Check if the string is empty
    if (!value) {
        return 'Latitude and Longitude are required.';
    }

    // 2. Split the string by comma and trim whitespace
    const parts = value.split(',').map((part) => part.trim());

    // 3. Ensure there are exactly two parts
    if (parts.length !== 2) {
        return `Format must be "latitude, longitude", ${example}`;
    }

    const [latStr, lngStr] = parts;

    // 4. Parse the parts as numbers
    const lat = parseFloat(latStr);
    const lng = parseFloat(lngStr);

    // 5. Validate that both are finite numbers
    if (!isFinite(lat) || !isFinite(lng)) {
        return `Latitude and Longitude must be numbers, ${example}`;
    }

    // 6. Validate the geographical ranges
    if (lat < -90 || lat > 90) {
        return `Latitude must be between -90 and 90, ${example}`;
    }
    if (lng < -180 || lng > 180) {
        return `Longitude must be between -180 and 180, ${example}`;
    }

    return true; // Return true if validation is successful
};


export const SingleEmailAddressRegex = /^[0-9a-zA-Z]+([0-9a-zA-Z]*[-._+])*[0-9a-zA-Z]+@[0-9a-zA-Z]+([-.][0-9a-zA-Z]+)*([0-9a-zA-Z]*[.])[a-zA-Z]{2,6}$/;
export const MultipleEmailAddressRegex = /^([A-Za-z0-9.-_]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,})(;(\s){0,1}[A-Za-z0-9.-]+@[A-Za-z0-9.-_]+\.[A-Za-z]{2,}){0,10}(;)?$/;

export const blurOnEnterKey = (e) => {if (e.keyCode === 13) { e.target.blur() }}
